/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useState } from "react";
import BondAnalyzer from "./bondAnalyzer";
import CouponReinvestmentVisualizer from "./couponReinvestmentVisualizer";

const VisualizerSwitcher = () => {
  const [selected, setSelected] = useState("bond");

  const renderComponent = () => {
    switch (selected) {
      case "bond":
        return <BondAnalyzer />;
      case "reinvestment":
        return <CouponReinvestmentVisualizer />;
      default:
        return null;
    }
  };

  const containerStyle = {
    padding: "30px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#eef2f5",
    minHeight: "100vh",
  };

  const labelStyle = {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: "10px",
    display: "block",
  };

  const selectStyle = {
    padding: "10px 15px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #90caf9",
    backgroundColor: "rgba(227,242,253,0.93)",
    color: "#1565c0",
    outline: "none",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    transition: "all 0.2s ease-in-out",
  };

  const componentWrapperStyle = {
    marginTop: "30px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)"
  };

  return (
        <div style={containerStyle}>
      <label htmlFor="visualizer" style={labelStyle}>🔍 Select a Visualizer</label>
      <select
        id="visualizer"
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        style={selectStyle}
      >
        <option value="bond">📊 Bond Analyzer</option>
        <option value="reinvestment">💸 Coupon Reinvestment Visualizer</option>
      </select>

      <div style={componentWrapperStyle}>
        {renderComponent()}
      </div>
    </div>
  );
};

export default VisualizerSwitcher;
